module.exports = __webpack_public_path__ + "static/media/emptyProfileCard.6d30346c.webp";